UC.views.ProposalTemplateIndexList = UC.components.ProposalTemplateListAbstract.extend({
  template: UC.views.resolveHandlebarsTemplate("components/proposal_template_index_list"),
});
